import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Portabilty_Afso from "./EkycUpdateReport_Afso";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';


function PortabilityDistrictTable() {
  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({});
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [renderContent, setRenderContent] = useState(null);
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const nextTableRef = useRef(null);
  const currentTableRef = useRef(null);

useEffect(() => {
  const fetchCurrentAndLoadData = async () => {
    try {
      const [mRes, yRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentMonth`),
        axios.get(`${process.env.REACT_APP_URL_HEADER}/Common/currentYear`),
      ]);

      const m = Number(mRes?.data?.month ?? mRes?.data);
      const y = Number(yRes?.data?.year ?? yRes?.data);

      setMonth(String(m));
      setYear(String(y));

      try {
        setLoading(true);
        setRenderContent(null);

        const response = await axios.post(
          `${process.env.REACT_APP_URL_SIDE}/EkycUpdated/District`,
          { month: String(m), year: String(y) }
        );

        if (response.data.message) {
          setMessage(response.data.message);
          setData([]);
        } else {
          setTitle(response.data.title);
          setData(response.data.data);
        }

        calculateTotals(response.data.data || []);
      } catch (error) {
        console.error("Error fetching district data", error);
        setMessage("Internal error");
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error getting month and year", error);
      setMessage("Failed to load current period");
      setLoading(false);
    }
  };

  fetchCurrentAndLoadData();
}, []); 

  const calculateTotals = (data) => {
    if (!data.length) return setTotals({});
    const totalsObj = data.reduce((totals, row) => {
      Object.entries(row).forEach(([key, value]) => {
        if (key !== "District" && typeof value === "number") {
          totals[key] = (totals[key] || 0) + value;
        }
      });
      return totals;
    }, {});
    setTotals(totalsObj);
  };

  const onDistrictClick = (distCode) => {
    if (currentTableRef.current) {
      const { bottom } = currentTableRef.current.getBoundingClientRect();
      window.scrollTo({
        top: window.scrollY + bottom + 10,
        behavior: "smooth",
      });
    }
    setRenderContent(
      <div ref={nextTableRef}>
        <Portabilty_Afso distCode={distCode} month={month} year={year}
          onDataLoaded={() => {
            setTimeout(() => {
              if (nextTableRef.current) {
                const top = nextTableRef.current.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                  top: top + 10,
                  behavior: "smooth"
                });
              }
            }, 10);
          }}
        />
      </div>
    )
  };
  const allSchemes = data.length > 0
    ? Array.from(new Set([
      ...Object.keys(data[0]?.total || {}),
      ...Object.keys(data[0]?.ekyc || {})
    ]))
    : [];

  const grandTotal = {};
  const grandEkyc = {};

  let grandTotal_cards = 0;
  let grandTotal_units = 0;
  let grandEkyc_cards = 0;
  let grandEkyc_units = 0;

  allSchemes.forEach(scheme => {
    grandTotal[scheme] = { cards: 0, units: 0 };
    grandEkyc[scheme] = { cards: 0, units: 0 };
  });

  data.forEach((dist) => {
    Object.entries(dist.total || {}).forEach(([scheme, values]) => {
      if (grandTotal[scheme]) {
        grandTotal[scheme].cards += Number(values.cards || 0);
        grandTotal[scheme].units += Number(values.units || 0);
      }
    });
    Object.entries(dist.ekyc || {}).forEach(([scheme, values]) => {
      if (grandEkyc[scheme]) {
        grandEkyc[scheme].cards += Number(values.cards || 0);
        grandEkyc[scheme].units += Number(values.units || 0);
      }
    });

    grandTotal_cards += Number(dist.total_cards || 0);
    grandTotal_units += Number(dist.total_units || 0);
    grandEkyc_cards += Number(dist.ekyc_cards || 0);
    grandEkyc_units += Number(dist.ekyc_units || 0);
  });


  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box></div>
  }


  return (
<div>
    <div align="center" style={{
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '700px',
                maxWidth: '90%',
                margin: '0 auto'
            }}>
          <br></br>
    <br></br>
    <br></br>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
          {CircularProgress}
        </Box></div>
      )}


      {!loading && (data.length > 0 ? (
        <table align="center" ref={currentTableRef} >
          <thead style={{
                        position: 'sticky',
                        top: 0,
                        background: '#fff',
                        zIndex: 10
                    }}>
            <tr className="tableheader" ><th colSpan={8 + allSchemes.length * 6}>{title}</th></tr>
            <tr className="tableheader" >
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>District</th>
              <th colSpan={2 + allSchemes.length * 2}>Total Beneficiaries</th>
              <th colSpan={2 + allSchemes.length * 2}>Updated Beneficiaries</th>
              <th colSpan={2 + allSchemes.length * 2}>% Percentage of completion</th>
            </tr>
            <tr className="tableheader">
              {allSchemes.map((scheme) => (
                <th key={scheme} colSpan={2}>
                  {scheme.toUpperCase()}
                </th>
              ))}
              <th colSpan={2}>Total</th>
              {allSchemes.map((scheme) => (
                <th key={`${scheme}-ekyc`} colSpan={2}>
                  {scheme.toUpperCase()}
                </th>
              ))}
              <th colSpan={2}>Total</th>
              {allSchemes.map((scheme) => (
                <th key={`${scheme}-ekyc`} colSpan={2}>
                  {scheme.toUpperCase()}
                </th>
              ))}
              <th colSpan={2}>Total</th>
            </tr>
            <tr className="tableheader">
              {allSchemes.flatMap((scheme) => [<th key={`${scheme}-total-cards`}>Cards</th>, <th key={`${scheme}-total-units`}>Units</th>])}
              <th >Cards</th>
              <th >Units</th>
              {allSchemes.flatMap((scheme) => [<th key={`${scheme}-ekyc-cards`}>Cards</th>, <th key={`${scheme}-ekyc-units`}>Units</th>])}
              <th >Cards</th>
              <th >Units</th>
              {allSchemes.flatMap((scheme) => [<th key={`${scheme}-ekyc-cards`}>Cards</th>, <th key={`${scheme}-ekyc-units`}>Units</th>])}
              <th >Cards</th>
              <th >Units</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) =>
              <tr key={index}>
                <td>{index + 1}</td>
                <td onClick={() => onDistrictClick(row.code)} style={{ cursor: 'pointer', color: 'blue' }}><u>{row.name}</u></td>
                {allSchemes.map((scheme) => {
                  const s = row.total?.[scheme];
                  return (
                    <>
                      <td align="right">{s.cards}</td>
                      <td align="right">{s.units}</td>
                    </>
                  );
                })}
                <td align="right">{row.total_cards}</td>
                <td align="right">{row.total_units}</td>
                {allSchemes.map((scheme) => {
                  const s = row.ekyc?.[scheme] ;
                  return (
                    <>
                      <td align="right">{s.cards}</td>
                      <td align="right">{s.units}</td>
                    </>
                  );
                })}
                <td align="right">{row.ekyc_cards}</td>
                <td align="right">{row.ekyc_units}</td>

                {allSchemes.map((scheme) => {
                  const s = row.ekyc?.[scheme];
                  const t = row.total?.[scheme];

                  return (
                    <>
                      <td align="right">
  {t.cards === 0 
    ? '0.00' 
    : (s.cards / t.cards * 100).toFixed(2)
  }
</td>
<td align="right">
  {t.units === 0 
    ? '0.00' 
    : (s.units / t.units * 100).toFixed(2)
  }
</td>
                    </>
                  );
                })}
                <td align="right">{((row.ekyc_cards / row.total_cards) * 100).toFixed(2)}</td>
                <td align="right">{((row.ekyc_units / row.total_units) * 100).toFixed(2)}</td>

              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className="tableheader" >
              <th colSpan={2}>Total</th>
              {allSchemes.map((scheme) => (
                <>
                  <td>{grandTotal[scheme]?.cards }</td>
                  <td>{grandTotal[scheme]?.units }</td>
                </>
              ))}
              <td>{grandTotal_cards}</td>
              <td>{grandTotal_units}</td>
              {allSchemes.map((scheme) => (
                <>
                  <td>{grandEkyc[scheme]?.cards }</td>
                  <td>{grandEkyc[scheme]?.units }</td>
                </>
              ))}
              <td>{grandEkyc_cards}</td>
              <td>{grandEkyc_units}</td>
              {allSchemes.map((scheme) => (
                <>
                  <td>{Number((grandEkyc[scheme]?.cards /grandTotal[scheme]?.cards )*100).toFixed(2)}</td>
                  <td>{Number((grandEkyc[scheme]?.units /grandTotal[scheme]?.units )*100).toFixed(2)}</td>
                </>
              ))}
              <td>{((grandEkyc_cards / grandTotal_cards) * 100).toFixed(2)}</td>
              <td>{((grandEkyc_units / grandTotal_units) * 100).toFixed(2)}</td>
            </tr>

          </tfoot>
        </table>
      ) : (
        <div class="response" align="center">{message}</div>
      ))}
      <br />

    </div>
          <br /><br />

          {renderContent}
      
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default PortabilityDistrictTable;
